<template>
  <layout-content>
    <i-button
      slot="top-buttons"
      type="primary"
      size="large"
      :to="{ name: 'pbx.time-condition.create' }"
    >
      {{ $t('pbx.breadcrumb.time-condition.create') }}
    </i-button>

    <table-component />
  </layout-content>
</template>

<script>
  import TableComponent from '@pbx/components/time-conditions/list/table';
  export default {
    components: {
      TableComponent
    }
  };
</script>
